import {
  AdminExamCenterProctorRequestHeader,
  AdminExamCenterProctorRequestDetailsProvider,
} from '@exam-center/proctor-request-management';
import { useParams } from '@exam-center/router';
import { Box } from '@shared/components';
import { Outlet } from 'react-router-dom';

export default function AdminProctorsRequestLayout() {
  const { requestId } = useParams('/admin/exam-proctors/requests/:requestId');

  return (
    <AdminExamCenterProctorRequestDetailsProvider examCenterProctorRequestId={requestId}>
      <AdminExamCenterProctorRequestHeader />
      <Box sx={{ p: (theme) => theme.spacing(6), flex: 1 }}>
        <Outlet />
      </Box>
    </AdminExamCenterProctorRequestDetailsProvider>
  );
}
